<template>
<div class="content-home">
    <div class="slideshow">
      <div class="content-width">
        <h1>SPECIALIST IN ADR / RID ADVIES</h1>
      </div>
      <div class="slide slide-1">
        <img src="../assets/slide-1.jpg" alt="">
      </div>
      <div class="slide slide-2">
        <img src="../assets/slide-2.jpg" alt="">
      </div>
    </div>
    <div class="intro">
      <div class="content-width">
        <h1>Waarom ADR advies?</h1>
        <p>
          Elke transportonderneming die gevaarlijke stoffen vervoert, opslaat of produceert, moet een veiligheidsadviseur benoemen of extern inhuren. Rojeca Advies in ADR / RID is er voor uw bedrijf om de beste oplossing te zoeken voor de verwerking en opslag van gevaarlijke stoffen. Bovendien adviseert Rojeca betrokken werknemers hoe zo veilig mogelijk met gevaarlijke stoffen om te gaan. Zo worden ernstige ongevallen voorkomen.
        </p>
        <router-link to="/contact"><button>
          <span class="margin-right-small">
            Kom nu in contact
          </span>
          <i class='fa arrow color-white'/>
        </button></router-link>

      </div>
    </div>
    <div class="kernpunten">
      <div class="content-width">
        <h1>Rojeca voor u</h1>
        <ul class="standout">
          <li>
            <i class='fa rules large color-primary'/>
            <div>
              Handhaving Regels
            </div>
          </li>
          <li>
            <i class='fa accident large color-tertiary'/>
            <div>
              Ongelukken Voorkomen
            </div>
          </li>
          <li>
            <i class='fa emergency large color-secondary'/>
            <div>
              Opstellen Noodprocedures
            </div>
          </li>
        </ul>

        <router-link to="/takenpakket"><button>
          <span class="margin-right-small">Lees meer</span>
          <i class='fa arrow color-white'/>
        </button></router-link>
      </div>
    </div>
</div>
</template>

<script>
export default {
  name: 'ContentHome',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
  mounted() {
    window.scrollTo(0, 0);
  }
}
</script>

<style>

.slideshow {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 280px;
  position: relative;
}

.intro {
  padding: var(--item-padding-large) 0;
  display: flex;
  justify-content: center;
}

.kernpunten {
  padding: var(--item-padding-large) 0;
  display: flex;
  justify-content: center;
  background: #eee;
}

.slideshow h1 {
  color: white;
  position: absolute;
  z-index: 2;
  top: calc(140px - 20px);
}

.slideshow .slide {
  position: absolute;
  width: 100%;
  display: flex;
}

.slideshow .slide-1 {
  background: #49a2de;
  justify-content: flex-end;
}

.slideshow .slide-2 {
  background: #023960;
  justify-content: flex-start;
  animation-name: slidefade;
  animation-duration: 12s;
  animation-iteration-count: infinite;
}

@keyframes slidefade {
  0%, 30% { opacity: 0; }
  50%, 80% { opacity: 1; }
  100% { opacity: 0; }
}

@media only screen and (max-width: 600px) {
  .slideshow .slide img {
    filter: brightness(0.8);
  }

  .slideshow h1 {
    text-shadow: 2px 2px #0004;
  }

  .kernpunten ul {
    flex-direction: column;
  }

  .kernpunten li:not(:last-child) {
    margin-bottom: var(--item-margin);
  }
}


</style>


// WEBPACK FOOTER //
// src/components/content-home.vue